import { always, mapObjIndexed, when } from 'ramda';
import gql from 'graphql-tag';
import { mutate, query } from '@/api/graphql';
import { getLanguage, isNullOrEmpty } from '@/helpers/misc';
import GetCategory from './graphql/queries/GetCategory.graphql';
import GetSubCategories from './graphql/queries/GetSubCategories.graphql';
import GetCategories from './graphql/queries/GetCategories.graphql';
import GetAllCategories from './graphql/queries/GetAllCategories.graphql';
import GetMainCategories from './graphql/queries/GetMainCategories.graphql';
import SaveCategory from './graphql/mutations/SaveCategory.graphql';
import Category from './graphql/fragments/category.graphql';

export const getCategory = async id => {
  const variables = { id };

  const { category } = await query(GetCategory, variables);

  return category;
};

export const getSubCategories = async contentTypes => {
  const variables = {
    filter: {
      contentTypes: [contentTypes],
      isApproved: true,
    },
  };

  const { subCategories } = await query(GetSubCategories, variables);

  return subCategories;
};

export const getCategories = async filter => {
  const modifiedFilter = mapObjIndexed(when(isNullOrEmpty, always(undefined)), filter);

  const variables = {
    filter: modifiedFilter,
  };

  const { categories } = await query(GetCategories, variables);

  return categories;
};

export const getAllCategories = async ({
  filter,
  page,
  limit,
}) => {
  const modifiedFilter = mapObjIndexed(when(isNullOrEmpty, always(undefined)), filter);

  if (isNullOrEmpty(modifiedFilter?.hierarchy)) {
    modifiedFilter.hierarchy = [];
  }

  const variables = {
    filter: modifiedFilter,
    page,
    limit,
    language: getLanguage(),
  };

  const { allCategories } = await query(GetAllCategories, variables);

  return allCategories;
};

export const getMainCategories = async () => {
  const variables = {
    filter: {
    },
  };

  const { mainCategories } = await query(gql`
    ${GetMainCategories}
    ${Category}
  `, variables);

  return mainCategories;
};

export const saveCategory = async input => {
  const variables = {
    input,
  };

  const result = await mutate(gql`
    ${SaveCategory}
  `, variables);

  return result;
};
